module.exports = __webpack_public_path__ + "img/ZMT_Logo_SMALL_cmyk_ENG.7e60454f.png";